/* File: sortUsersByName.js
 * Path: ananunadm/src/helpers/sortUsersByName.js
*/

const getLocalized = (value, lang = "en") => {
	if (!value) return "";
	if (typeof value === "string") return value;
	return value[lang] || value.en || value.hy || value.ru || Object.values(value).find(Boolean) || "";
};

/** Display name used to order user lists: name -> firstName+lastName -> username -> email. */
export const getUserSortLabel = (user, lang = "en") => {
	if (!user || typeof user !== "object") return "";
	const name = getLocalized(user.name, lang);
	if (name) return name;
	const fullName = [getLocalized(user.firstName, lang), getLocalized(user.lastName, lang)]
		.filter(Boolean)
		.join(" ");
	if (fullName) return fullName;
	return user.username || getLocalized(user.email, lang) || "";
};

export const sortUsersByName = (users, lang = "en") =>
	Array.isArray(users)
		? [...users].sort((a, b) => getUserSortLabel(a, lang).localeCompare(getUserSortLabel(b, lang), lang))
		: users;

/** Sort already-built {label, value} select options by their label. */
export const sortOptionsByLabel = (options, lang = "en") =>
	Array.isArray(options)
		? [...options].sort((a, b) => String(a?.label || "").localeCompare(String(b?.label || ""), lang))
		: options;

export default sortUsersByName;
